import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ANALYTICS_REPOSITORY } from '../domain/repositories/analytics.repository';
import { AnalyticsRemoteDatasource } from './datasources/remote/analytics.remote-datasource';
import { AnalyticsMapper } from './mappers/analytics.mapper';
import { AnalyticsRepositoryImpl } from './repositories/analytics.repository.impl';

export function provideAnalyticsData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    AnalyticsRemoteDatasource,
    AnalyticsMapper,
    { provide: ANALYTICS_REPOSITORY, useClass: AnalyticsRepositoryImpl },
  ]);
}
